import React from "react";

function TableHeader({ columns, sort, handleSort }) {
  return (
    // <thead className="text-center align-middle user-select-none">
    <thead className="align-middle user-select-none">
      <tr className="tea2-table__header-row">
        {columns.map((column) => {
          const sortIcon = () => {
            if (column.accessor === sort.orderBy) {
              if (sort.order === "asc") {
                return "↑";
              }
              return "↓";
            } else {
              return "️↕️";
            }
          };
          return (
            <th key={column.accessor}>
              {column.sortable ? (
                <span
                  role="button"
                  className="text-truncate"
                  onClick={() => handleSort(column.accessor)}
                >
                  {column.label} <span className="ms-2">{sortIcon()}</span>
                </span>
              ) : (
                <span className="text-truncate">{column.label}</span>
              )}
            </th>
          );
        })}
      </tr>
    </thead>
  );
}

export default TableHeader;
